import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';
import type { ApiQualificationsResponse } from '@/rennovation/planning-view/types/api/qualifications-response';
import { useI18n } from 'vue-i18n';
import { useAlertStore } from '@/rennovation/planning-view/store/useAlertStore';

export const useQualificationBridgeStore = defineStore('qualificationBridge', () => {
	const { t } = useI18n();

	const vuex = useStore();
	const alertStore = useAlertStore();

	const qualifications = computed<ApiQualificationsResponse>(() => vuex.state.qualification.qualifications || []);

	const activeQualifications = computed<ApiQualificationsResponse>(() => {
		return qualifications.value.filter((q) => !q.deleted);
	});

	const loadQualifications = async (): Promise<void> => {
		try {
			await vuex.dispatch('qualification/load');
		} catch (error) {
			console.error('Failed to load qualifications via bridge store:', error);
			const errorMessage = error?.response?.data?.message || t('data_load_failed');
			alertStore.showAlert(errorMessage, 'error');
			throw error;
		}
	};

	return {
		qualifications,
		activeQualifications,
		loadQualifications,
	};
});
